import { render, staticRenderFns } from "./CertificationForwardDialog.vue?vue&type=template&id=278f3eac&"
import script from "./CertificationForwardDialog.vue?vue&type=script&lang=js&"
export * from "./CertificationForwardDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports